<div class="label mb-2 font-bold"><ng-content /></div>

<div class="chip-grid">
  @for (chip of state$ | async; track trackByValue($index, chip)) {
    <div [matTooltip]="chip.tooltip ?? ''">
      <mat-chip
        (click)="toggle(chip.value)"
        [highlighted]="chip.selected"
        [disabled]="chip.disabled"
      >
        <span class="!text-cp-primary-100">{{ chip.label }}</span>
      </mat-chip>
    </div>
  }
</div>
